<template>
	<div class="tentang">
		<div class="container">
			<div class="card-tentang mt-5">
				<div class="row">
					<div class="col-lg-3 d-flex	justify-content-start">
						<div class="card no-border img-card-tentang">
							<img src="../assets/sekilas-pusbuk.png" class="" alt="...">
						</div>
					</div>
					<div class="col">
					</div>
				</div>
				<div class="row">
					<div class="col"></div>
					<div class="col-lg-10 d-flex justify-content-end">
						<div class="card no-border text-card-tentang bg-wavesw-l-1">
							<div class="card-body pt-0">
								<h3 class="card-title f-white mb-3">Tentang Pusbuk</h3>
								<p class="card-text">Ibarat sebuah perjalanan panjang yang berliku, demikian pula sejarah perbukuan atau penerbitan buku di Indonesia. Sejatinya perbukuan di Indonesia telah dimulai sejak abad k-19 ketika Belanda melalui VOC memboyong mesin cetak ke Indonesia. Perbukuan di Indonesia tidak terlepas dari peran Pemerintah Hindia Belanda. Mereka memboyong mesin cetak, operator cetak, dan para ahli penerbitan untuk berkiprah di Indonesia.</p>
								<p class="card-text">
									Tahun 2017 menjadi tonggak bersejarah bagi dunia perbukuan di Indonesia
									ketika Pemerintah mengesahkan Undang-Undang Nomor 3 Tahun 2017 tentang
									Sistem Perbukuan yang kemudian ditindaklanjuti dengan pengesahan Peraturan
									Pemerintah Nomor 75 Tahun 2019 tentang Peraturan Pelaksanaan UndangUndang Nomor 3 Tahun 2017 tentang Sistem Perbukuan. Kementerian Pendidikan,
									Kebudayaan, Riset, dan Teknologi (Kemdikbudristek) telah mendapat amanat
									menjadi induk dari dunia perbukuan di Indonesia. Untuk itu, lembaga perbukuan
									yang kini bernama Pusat Perbukuan berada di bawah Badan Standar, Kurikulum,
									dan Asesmen Pendidikan di Kementerian dasar dan menegah melaksanan tugas dan fungsi
									pengelolaan ekosistem perbukuan nasional.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bg-dot-l-3">
			<div class="container visimisi mt-5 pb-5">
				<div class="row">
					<div class="col">
						<h3 class="card-title mt-2 mb-3">Visi</h3>
						<p>"Kementerian Pendidikan Dasar dan Menengah mendukung Visi dan Misi Presiden untuk mewujudkan Indonesia Maju yang berdaulat, mandiri, dan berkepribadian melalui terciptanya Pelajar Pancasila yang bernalar kritis, kreatif, mandiri, beriman, bertakwa kepada Tuhan Yang Maha Esa, dan berakhlak mulia, bergotong royong, dan berkebinekaan global"</p>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<h3 class="card-title mt-2 mb-3">Misi</h3>
						<ul class="round">
							<li><p class="mb-2">Mewujudkan pendidikan yang relevan dan berkualitas tinggi, merata dan berkelanjutan, didukung oleh infrastruktur dan teknologi.</p></li>
							<li><p class="mb-2">Mewujudkan pelestarian dan pemajuan kebudayaan serta pengembangan bahasa dan sastra.</p></li>
							<li><p class="mb-2">Mengoptimalkan peran serta seluruh pemangku kepentingan untuk mendukung transformasi dan reformasi pengelolaan pendidikan dan kebudayaan.</p></li>
						</ul>
					</div>
				</div>
				
				<!-- Bagian Dokumen Performa Pusbuk -->
				<div class="row mt-5">
					<div class="col">
						<h3 class="card-title mt-2 mb-3">Dokumen Performa dan Perencanaan</h3>
						<p class="mb-4">Sebagai bentuk transparansi dan akuntabilitas publik, Pusat Perbukuan menyediakan berbagai dokumen performa dan perencanaan yang dapat diakses oleh masyarakat. Dokumen-dokumen ini mencerminkan komitmen kami dalam memberikan layanan terbaik untuk ekosistem perbukuan Indonesia.</p>
					</div>
				</div>
				
				<div class="row mt-4">
					<div class="col-lg-6">
						<h5 class="mb-3">Laporan Kinerja</h5>
						<div class="list-group mb-4">
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Laporan%20Kinerja%20Pusat%20Perbukuan%20Tahun%202024.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Laporan Kinerja 2024</h6>
									<small class="text-muted">Evaluasi pencapaian kinerja tahun 2024</small>
								</div>
								<span class="badge bg-primary rounded-pill">PDF</span>
							</a>
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Laporan%20Kinerja%20Pusat%20Perbukuan%20Tahun%202023.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Laporan Kinerja 2023</h6>
									<small class="text-muted">Evaluasi pencapaian kinerja tahun 2023</small>
								</div>
								<span class="badge bg-primary rounded-pill">PDF</span>
							</a>
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Laporan%20Kinerja%20Pusat%20Perbukuan%20Tahun%202022.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Laporan Kinerja 2022</h6>
									<small class="text-muted">Evaluasi pencapaian kinerja tahun 2022</small>
								</div>
								<span class="badge bg-primary rounded-pill">PDF</span>
							</a>
							<a href="https://drive.google.com/file/d/1nHM0dl_D1XeP84JZL21iO7I1Xs2x1Apg/view?usp=sharing" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Laporan Kinerja 2025</h6>
									<small class="text-muted">Evaluasi pencapaian kinerja tahun 2025</small>
								</div>
								<span class="badge bg-primary rounded-pill">PDF</span>
							</a>
						</div>
					</div>
					
					<div class="col-lg-6">
						<h5 class="mb-3">Perjanjian Kinerja</h5>
						<div class="list-group mb-4">
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Perjanjian%20Kinerja%20Awal%20Pusat%20Perbukuan%20Tahun%202025.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Perjanjian Kinerja Awal 2025</h6>
									<small class="text-muted">Target kinerja awal tahun 2025</small>
								</div>
								<span class="badge bg-success rounded-pill">PDF</span>
							</a>
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Perjanjian%20Kinerja%20Akhir%20Pusat%20Perbukuan%20Tahun%202024.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Perjanjian Kinerja Akhir 2024</h6>
									<small class="text-muted">Revisi target kinerja tahun 2024</small>
								</div>
								<span class="badge bg-success rounded-pill">PDF</span>
							</a>
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Perjanjian%20Kinerja%20Awal%20Pusat%20Perbukuan%20Tahun%202024.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Perjanjian Kinerja Awal 2024</h6>
									<small class="text-muted">Target kinerja awal tahun 2024</small>
								</div>
								<span class="badge bg-success rounded-pill">PDF</span>
							</a>
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Perjanjian%20Kinerja%20Akhir%20Pusat%20Perbukuan%20Tahun%202023.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Perjanjian Kinerja Akhir 2023</h6>
									<small class="text-muted">Revisi target kinerja tahun 2023</small>
								</div>
								<span class="badge bg-success rounded-pill">PDF</span>
							</a>
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Perjanjian%20Kinerja%20Awal%20Pusat%20Perbukuan%20Tahun%202023.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Perjanjian Kinerja Awal 2023</h6>
									<small class="text-muted">Target kinerja awal tahun 2023</small>
								</div>
								<span class="badge bg-success rounded-pill">PDF</span>
							</a>
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Perjanjian%20Kinerja%20Pusat%20Perbukuan%20Tahun%202022.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Perjanjian Kinerja 2022</h6>
									<small class="text-muted">Target kinerja tahun 2022</small>
								</div>
								<span class="badge bg-success rounded-pill">PDF</span>
							</a>
							<a href="https://drive.google.com/file/d/1_tzTeQyc_Rq_SPNP1yylGh7AsVEhb88a/view?usp=sharing" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Perjanjian Kinerja Akhir 2025</h6>
									<small class="text-muted">Revisi target kinerja tahun 2025</small>
								</div>
								<span class="badge bg-success rounded-pill">PDF</span>
							</a>
						</div>
					</div>
				</div>
				
				<div class="row mt-4">
					<div class="col-lg-6">
						<h5 class="mb-3">Dokumen Strategis</h5>
						<div class="list-group">
							<a href="https://files.cloudapp.web.id/buku/kebijakan/Renstra%20Pusat%20Perbukuan%20Tahun%202022-2024.pdf" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Renstra Pusat Perbukuan 2022-2024</h6>
									<small class="text-muted">Rencana strategis pengembangan perbukuan</small>
								</div>
								<span class="badge bg-warning text-dark rounded-pill">PDF</span>
							</a>
							<a href="https://drive.google.com/file/d/1RD6UN5CilmSy7dSehQoGqKiXJHvB1jHb/view?usp=sharing" 
								target="_blank" 
								class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
								<div>
									<h6 class="mb-1">Renstra Pusat Perbukuan 2025-2029</h6>
									<small class="text-muted">Rencana strategis pengembangan perbukuan</small>
								</div>
								<span class="badge bg-warning text-dark rounded-pill">PDF</span>
							</a>
						</div>
					</div>
				</div>
				
				<!-- <div class="row">
					<div class="col-lg-8">
						<div class="row">
							<div class="col">
								<h3 class="card-title mt-2 mb-3">Tujuan</h3>
								
								<p>Tujuan penyusunan buku dalam ekosistem perbukuan Indonesia ini sangat penting, yaitu sebagai:</p>
				
								<ul class="round">
									<li><p class="mb-2">Mikrosejarah pemerintah Indonesia untuk diwariskan kepada generasi mendatang;</p></li>
									<li><p class="mb-2">Lesson learned tentang politik dan kebijakan perbukuan pemerintah dalam lintas sejarah;</p></li>
									<li><p class="mb-2">Referensi sejarah dalam konteks perbukuan yang dapat membantu penelitian ilmiah berbasis perbukuan; </p></li>
									<li><p class="mb-2">Manajemen pengetahuan yang terdokumentasikan; dan</p></li>
									<li><p class="mb-2">Referensi kebijakan perbukuan yang dapat menjadi rujukan penyusunan kebijakan perbukuan pada masa yang akan datang.</p></li>
								</ul>

							</div>
						</div>
						<div class="row">
							<div class="col">
								<h3 class="card-title mt-2 mb-3">Produk</h3>
								<p>Ikhtiar mengumpulkan informasi tentang perbukuan Indonesia ini bermuara pada lahirnya suatu produk berupa buku sejarah perbukuan Indonesia. Penyajian buku ini dibagi dalam dua fase sejarah. Fase pertama adalah era prakemerdekaan Indonesia, dan fase kedua adalah era pascakemerdekaan Indonesia. Era prakemerdekaan ditandai dengan munculnya penerbitan Hiindia Belanda, penerbitan Cina Peranakan, dan penerbitan Bumiputera. Era pascakemerdekaan dimulai dengan munculnya penerbitan swasta (partikelir), penerbitan pemerintah, dan penerbitan perguruan tinggi.</p>
							</div>
						</div>
					</div>
					<div class="col-lg-4 text-center pt-5">
						<img src="../assets/visi-misi.png" alt="...">
					</div>
				</div> -->
			</div>
		</div>
		<div class="wrap-full bg-sm-trans-bw">
			<div class="container py-10">
				<div class="row">
					<div class="col">
						<h3 class="card-title mt-0 mb">Sejarah Singkat Pusbuk</h3>
					</div>
				</div>
				<div class="row mt-5">
					<div class="col-lg-12">
						<section class="timeline_area section_padding_130">
							<div class="container">
								<div class="row">
									<div class="col-12">
										<div class="apland-timeline-area" v-if="data_tls.length > 0">
											<div class="single-timeline-area"  v-for="(item, i) in data_tls" :key="i">
												<div class="timeline-date">
													<h5 class="text-end">{{ item.tahun }}</h5>
												</div>
												<div class="row py-3">
													<div class="col">
														<div class="single-timeline-content d-flex pt-3">
															<div class="timeline-icon">
																<img :src="require('../assets/'+item.image)" alt="...">
															</div>
														</div>
													</div>
													<div class="col-lg-8">
														<div class="single-timeline-content d-flex">
															<div v-if="!item.show_desk">
																<div class="timeline-text py-3" v-html="item.intro">
																</div>
																<span class="position-absolute"><button class="link-blue bg-transparent border-0 ps-0" v-on:click='showDesk(item.id)'>selengkapnya &gt;</button></span>
															</div>
															<div v-else>
																<div class="timeline-text py-3" v-html="item.deskripsi">
																</div>
																<span class="position-absolute"><button class="link-blue bg-transparent border-0 ps-0" v-on:click='hideDesk(item.id)'>&lt; kembali</button></span>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-lg-10 mx-auto">
														<hr>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
		<div class="wrap-full py-5 struktur bg-dot-l-1">
			<div class="container py-5">
				<div class="row">
					<div class="col text-center">
						<h3 class="card-title mt-0 mb">Struktur Organisasi</h3>
					</div>
				</div>
				<div class="row mt-5">
					<div class="col-lg-10 mx-auto">
						<img src="../assets/struktur-organisasi-2.png" class="img-struktur" alt="...">
					</div>
				</div>
				<div class="row mt-2">
					<div class="row mt-7 justify-content-center">
						<div class="col-lg-12">
							<div class="card no-border">
								<div class="card-body px-0 py-2 text-center">
									<img class="mb-4 img-struktur-profil" src="../assets/stakeholder/supriyatno.png" width="200" alt="">
									<h6 class="card-title mb-2">Supriyatno, S.Pd., M.A.</h6>
									<p class="card-text mb-5">Kepala Pusat Perbukuan</p>
								</div>
							</div>
						</div>
						<div class="col-lg-4">
							<div class="card no-border">
								<div class="card-body px-0 py-2 text-center">
									<img class="mb-4 img-struktur-profil" src="../assets/stakeholder/eka-setiawati.png" width="200" alt="">
									<h6 class="card-title mb-2">Eka Setiawati, S.Kom., M.Ak</h6>
									<p class="card-text mb-5">Kepala Bidang Tata Kelola Sistem dan Sumber Daya Perbukuan</p>
								</div>
							</div>
						</div>
						<div class="col-lg-4">
							<div class="card no-border">
								<div class="card-body px-0 py-2 text-center">
									<img class="mb-4 img-struktur-profil" src="../assets/stakeholder/livya-chairunnisa.png" width="210" alt="">
									<h6 class="card-title mb-2">Livya Chairunnisa Ahdiati, A.Md</h6>
									<p class="card-text mb-5">Kepala Sub Bagian Tata Usaha</p>
								</div>
							</div>
						</div>
					</div>
					<div class="row justify-content-center">
						<div class="col-lg-3">
							<div class="card no-border">
								<div class="card-body px-0 py-2 text-center">
									<img class="mb-4 img-struktur-profil" src="../assets/stakeholder/wijanarko-adi-nugroho.png" width="200" alt="">
									<h6 class="card-title mb-2">Wijanarko Adi Nugroho, S.Si</h6>
									<p class="card-text mb-5">Pejabat Pembuat Komitmen</p>
								</div>
							</div>
						</div>
						<div class="col-lg-3">
							<div class="card no-border">
								<div class="card-body px-0 py-2 text-center">
									<img class="mb-4 img-struktur-profil" src="../assets/stakeholder/tri-wahyuningsih.png" width="200" height="256" style="object-fit: cover; object-position: center top;" alt="">
									<h6 class="card-title mb-2">Tri Wahyuningsih, A.Md</h6>
									<p class="card-text mb-5">Bendahara Pengeluaran</p>
								</div>
							</div>
						</div>
						<div class="col-lg-3">
							<div class="card no-border">
								<div class="card-body px-0 py-2 text-center">
									<img class="mb-4 mt-4 img-struktur-profil" src="../assets/stakeholder/maharani-praningrum.png" width="210" alt="">
									<h6 class="card-title mb-2">Maharani Praningrum, S.Si., M.A</h6>
									<p class="card-text mb-5">Ketua Tim Kerja Penyusunan dan Penilaian Buku SD, SMP, dan SMA</p>
								</div>
							</div>
						</div>
						<div class="col-lg-3">
							<div class="card no-border">
								<div class="card-body px-0 py-2 text-center">
									<img class="mb-4 mt-4 img-struktur-profil" src="../assets/stakeholder/futri-fuji-wijayanti.png" width="200" alt="">
									<h6 class="card-title mb-2">Futri Fuji Wijayanti, S.Hum., M.A</h6>
									<p class="card-text mb-5">Ketua Tim Kerja Penyusunan dan Penilaian Buku PAUD, DIKSUS, dan Vokasi</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import tls_json from '@/assets/json/data_tlsejarah.json'
export default {
	name: 'Tentang',
	data(){
		return{
			data_tls: tls_json
		}
	},
	methods:{
		showDesk(id){
			const index = this.data_tls.findIndex(object => {
				return object.id === id;
			})
			this.data_tls[index].show_desk = true
		},
		hideDesk(id){
			const index = this.data_tls.findIndex(object => {
				return object.id === id;
			})
			this.data_tls[index].show_desk = false
		}
	}
}
</script>